'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { CartCount } from '@/app/donation/(private)/cart/_components/CartItems/CartCount';
import { BottomSheet } from '../../_components/BottomSheet';
import { OptionPriceSummary } from '../../_components/OptionPriceSummary';
import { OptionSelectBox } from '../../_components/OptionSelectBox';
import { optionKey } from '../_utils/cartCalculations';
import type { CartOption, CartProduct } from './CartShopGroup';
interface LocalOption extends CartOption {
  isSelected: boolean;
}
interface CartBottomBarProps {
  discountAmount: number;
  finalAmount: number;
  totalCount: number;
  paymentDisabled?: boolean;
  editingProduct?: {
    product: CartProduct;
    allOptions: CartOption[];
  } | null;
  onEditClose?: () => void;
  onEditConfirm?: (updatedOptions: CartOption[]) => void;
  onOrder?: () => void;
}
export const CartBottomBar = t0 => {
  const $ = _c(47);
  const {
    discountAmount,
    finalAmount,
    totalCount,
    paymentDisabled: t1,
    editingProduct,
    onEditClose,
    onEditConfirm,
    onOrder
  } = t0;
  const paymentDisabled = t1 === undefined ? false : t1;
  const isEditing = !!editingProduct;
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [localOptions, setLocalOptions] = useState(t2);
  let t3;
  let t4;
  if ($[1] !== editingProduct) {
    t3 = () => {
      if (editingProduct) {
        setLocalOptions(editingProduct.product.options.filter(_temp).map(_temp2));
        setIsOptionOpen(false);
      } else {
        setLocalOptions([]);
        setIsOptionOpen(false);
      }
    };
    t4 = [editingProduct];
    $[1] = editingProduct;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let T0;
  let T1;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== discountAmount || $[5] !== editingProduct || $[6] !== finalAmount || $[7] !== isEditing || $[8] !== isOptionOpen || $[9] !== localOptions || $[10] !== onEditClose || $[11] !== onEditConfirm || $[12] !== onOrder || $[13] !== paymentDisabled || $[14] !== totalCount) {
    const availableOptions = editingProduct ? editingProduct.allOptions.filter(_temp3) : [];
    let t10;
    if ($[22] !== localOptions) {
      t10 = localOptions.reduce(_temp4, 0);
      $[22] = localOptions;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    const totalAmount = t10;
    let handleQuantityChange;
    let handleSelectOption;
    if ($[24] !== localOptions) {
      handleSelectOption = option => {
        const key = optionKey(option);
        const existing = localOptions.find(lo => optionKey(lo) === key);
        if (existing) {
          handleQuantityChange(existing.cartItemOptionId, existing.quantity + 1);
        } else {
          setLocalOptions(prev => [...prev, {
            ...option,
            quantity: 1,
            isSelected: true
          }]);
        }
        setIsOptionOpen(false);
      };
      handleQuantityChange = (cartItemOptionId, quantity) => {
        setLocalOptions(prev_0 => prev_0.map(opt_3 => opt_3.cartItemOptionId === cartItemOptionId ? {
          ...opt_3,
          quantity
        } : opt_3));
      };
      $[24] = localOptions;
      $[25] = handleQuantityChange;
      $[26] = handleSelectOption;
    } else {
      handleQuantityChange = $[25];
      handleSelectOption = $[26];
    }
    let t11;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = cartItemOptionId_0 => {
        setLocalOptions(prev_1 => prev_1.filter(opt_4 => opt_4.cartItemOptionId !== cartItemOptionId_0));
      };
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    const handleRemoveOption = t11;
    let t12;
    if ($[28] !== localOptions || $[29] !== onEditClose || $[30] !== onEditConfirm) {
      t12 = () => {
        onEditConfirm?.(localOptions);
        onEditClose?.();
      };
      $[28] = localOptions;
      $[29] = onEditClose;
      $[30] = onEditConfirm;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    const handleConfirm = t12;
    T1 = BottomSheet;
    const t13 = discountAmount > 0 && "-";
    let t14;
    if ($[32] !== discountAmount) {
      t14 = <CountUp preserveValue={true} duration={0.5} end={discountAmount} separator="," />;
      $[32] = discountAmount;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    if ($[34] !== t13 || $[35] !== t14) {
      t7 = <p className="font-700 text-Gray-white typo-caption1">{"\uC608\uC0C1 \uD560\uC778 \uAE08\uC561 "}<span className="text-O-400">{t13}{t14}원</span></p>;
      $[34] = t13;
      $[35] = t14;
      $[36] = t7;
    } else {
      t7 = $[36];
    }
    t8 = isEditing;
    t9 = onEditClose;
    T0 = AnimatePresence;
    t5 = "wait";
    t6 = isEditing ? <motion.div key="edit" initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      height: {
        duration: 0.3,
        ease: "easeOut"
      },
      opacity: {
        duration: 0.2,
        delay: 0.05
      }
    }} className="-mt-8 overflow-hidden"><div className="flex flex-col gap-12 pt-24"><OptionSelectBox options={availableOptions.map(_temp5)} isOpen={isOptionOpen} onToggle={() => setIsOptionOpen(!isOptionOpen)} onSelectOption={opt_6 => {
          const original = availableOptions.find(o => o.cartItemOptionId === opt_6.id);
          if (original) {
            handleSelectOption(original);
          }
        }} />{localOptions.length > 0 && <ul className="flex max-h-240 flex-col overflow-y-auto">{localOptions.map((option_0, index) => <li key={option_0.cartItemOptionId} className={cn("flex flex-col gap-12 py-16", index > 0 && "border-t border-Gray-200")}><p className="font-400 text-Gray-900 typo-body4">{String(index + 1).padStart(2, "0")}.{" "}{option_0.optionName}{option_0.extraPrice > 0 && ` (+${option_0.extraPrice.toLocaleString()}원)`}</p><div className="flex items-center justify-between"><CartCount className="rounded-none" count={option_0.quantity} onCountChange={count => handleQuantityChange(option_0.cartItemOptionId, count)} onDelete={() => handleRemoveOption(option_0.cartItemOptionId)} /><span className="font-600 text-Gray-900 typo-body4">{(option_0.price * option_0.quantity).toLocaleString()}원</span></div></li>)}</ul>}</div><OptionPriceSummary totalAmount={totalAmount} /><Button theme="primary-fill" dimensions="H56" className="w-full !rounded-none bg-O-400 font-700 hover:bg-O-300" onClick={handleConfirm}>옵션 변경</Button></motion.div> : <motion.div key="default" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }}><Button disabled={paymentDisabled || totalCount === 0} className={cn("flex h-56 w-full items-center justify-center gap-4 !rounded-none hover:border-O-500 hover:bg-O-500", paymentDisabled || totalCount === 0 ? "bg-Gray-100" : "bg-O-400")} onClick={onOrder}><span className={cn("font-700 typo-body4", paymentDisabled || totalCount === 0 ? "text-Gray-400" : "text-Gray-white")}><CountUp preserveValue={true} duration={0.5} end={Math.max(0, finalAmount)} separator="," />원</span><span className={cn("font-700 typo-body4", paymentDisabled || totalCount === 0 ? "text-Gray-400" : "text-Gray-white")}>결제하기</span><span className="flex size-16 items-center justify-center rounded-pill bg-Gray-white"><span className={cn("font-800", paymentDisabled || totalCount === 0 ? "text-Gray-400" : "text-O-400")} style={{
            fontSize: 12
          }}>{totalCount}</span></span></Button></motion.div>;
    $[4] = discountAmount;
    $[5] = editingProduct;
    $[6] = finalAmount;
    $[7] = isEditing;
    $[8] = isOptionOpen;
    $[9] = localOptions;
    $[10] = onEditClose;
    $[11] = onEditConfirm;
    $[12] = onOrder;
    $[13] = paymentDisabled;
    $[14] = totalCount;
    $[15] = T0;
    $[16] = T1;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t10;
  if ($[37] !== T0 || $[38] !== t5 || $[39] !== t6) {
    t10 = <T0 mode={t5}>{t6}</T0>;
    $[37] = T0;
    $[38] = t5;
    $[39] = t6;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  let t11;
  if ($[41] !== T1 || $[42] !== t10 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t11 = <T1 toast={t7} backdrop={t8} onBackdropClick={t9}>{t10}</T1>;
    $[41] = T1;
    $[42] = t10;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t11;
  } else {
    t11 = $[46];
  }
  return t11;
};
function _temp(opt) {
  return !opt.soldOutYN;
}
function _temp2(opt_0) {
  return {
    ...opt_0,
    isSelected: true
  };
}
function _temp3(opt_1) {
  return !opt_1.soldOutYN;
}
function _temp4(sum, opt_2) {
  return sum + opt_2.price * opt_2.quantity;
}
function _temp5(opt_5) {
  return {
    ...opt_5,
    id: opt_5.cartItemOptionId,
    name: opt_5.optionName
  };
}